// Appoinment.js

import { useEffect } from "react";

function Appoinment() {
  useEffect(() => {
    // Perform the redirection when the component mounts
    window.location.href = "https://app.reclaim.ai/m/varshini/lets-talk";
  }, []); // Empty dependency array ensures that this effect runs only once

  return null;
}

export default Appoinment;
